import React from "react";
import styled from "styled-components";
// import SidebarOption from "./SidebarOption";
import { SidebarDataForMenu } from "./SidebarDataForMenu";
import { useStateValue } from "../../StateProvider";

import Link from "./Link";

const NavLinksContainer = styled.div`
 height: 100%;
 display: flex;
 align-items: center;

`;

const LinksWrapper = styled.ul `

margin: 0;
padding: 0;
display: flex;
height: 100%;
list-style: none;
background-color: rgb(240, 240, 240);

`;

//LINIEN OBEN NAVI BEI border-top: hier
const LinkItem = styled.li`
  height: 100%;
  padding: 0 1.1em;
  color: #222;
  font-weight: 500;
  font-size: 24px;
  color: #0d7a2b;
  align-items: center;
  justify-content: center;
  display: flex;
  transition: all 220ms ease-in-out;


  &:hover {
    color: #1db954;
    transform: scale(1.05);
  }
`;

// const Link = styled.a `


// text-decoration: none;
// color: inherit;
// font-size: inherit;
// `;
export function NavLinks(props) {

  const [{testmode}, dispatch] = useStateValue();

  const handleAddSongClick = () => {
    dispatch({
      type: "SET_MENUSTATE",
      menustate: "addownsong",
    });
  };



    return (
    <NavLinksContainer>
        <LinksWrapper>

        {SidebarDataForMenu.map((item, index) => {


return <LinkItem key={index}><Link option={item.title} path={item.path} > </Link></LinkItem>


})}

        {/* Test mode: Add Song menu item */}
        {testmode && (
          <LinkItem onClick={handleAddSongClick} style={{ cursor: 'pointer' }}>
            <div>
              <button type="button"><h4>Add Song</h4></button>
            </div>
          </LinkItem>
        )}


            {/* <LinkItem><Link href="#">Song Carousel</Link></LinkItem>
            <LinkItem><Link href="#">Rating of My Songs</Link></LinkItem>
            <LinkItem><Link href="#">How it works</Link></LinkItem>
            <LinkItem><Link href="#">FAQ</Link></LinkItem> */}
        </LinksWrapper>
    </NavLinksContainer>
    );




  }
